import React from 'react';

import { Help } from '@gogame/components';

export const TextWithInfo = ({ children, info }) => {
  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      {children}
      <Help>{info}</Help>
    </span>
  );
};

export default TextWithInfo;
